import { globalToaster } from 'components/elements/global'
import { queryClient } from 'lib/react-query'
import { ApiResponce } from 'types'
import { baseAPI } from 'api/baseApi'
import { updateNotificationChatActionInCache } from 'components/layout-modules/NoticationModule/functions'
import {
 addChatMessageToCache,
 updateChatMessageToCache,
 removeTempChatMessageFromCache,
 markChatAsReadInCache,
} from '../functions'
import {
 TChatNotificationActionB,
 TGetChatMessage,
 TPostChatMessage,
} from '../types'

export const baseTransformResponse = (resp: ApiResponce) => {
 if (resp.status === 'error') {
  globalToaster({ type: 'error', content: resp.message })
 } else {
  globalToaster({ type: 'success', content: resp.message })
 }
}

export const chatCrm = baseAPI.injectEndpoints({
 endpoints: ({ query, mutation }) => ({
  sendMessage: mutation<TGetChatMessage, TPostChatMessage>({
   query: (body) => ({
    method: 'post',
    url: 'user/chat/send',
    body,
   }),
   transformResponse: (data: ApiResponce) => data.data,
   async onQueryStarted(body, { queryFulfilled }) {
    const { lead_id, message, temp_id } = body
    if (temp_id) {
     addChatMessageToCache(lead_id, {
      tempId: temp_id,
      message,
      status: 'sent',
      message_sender: 'expert',
      created_at: new Date().toISOString(),
      lead_email: '', // Placeholder
     })
    }
    try {
     const { data } = await queryFulfilled
     if (data && temp_id) {
      updateChatMessageToCache(lead_id, temp_id, {
       ...data,
       status: 'delivered',
      })
     }
    } catch {
     if (temp_id) {
      removeTempChatMessageFromCache(lead_id, temp_id)
     }
    }
   },
  }),
  notificationChatAction: mutation<any, TChatNotificationActionB>({
   query: (body) => ({
    url: 'user/chat/join',
    body,
    method: 'post',
   }),
   transformResponse: (data: ApiResponce) => {
    if (data.status === 'success') {
     globalToaster({ type: 'success', content: data.message })
    } else {
     globalToaster({ type: 'error', content: data.message })
    }
   },
   async onQueryStarted(body, { queryFulfilled }) {
    const { notification_id, type } = body
    if (notification_id) {
     updateNotificationChatActionInCache(notification_id, type)
    }
    try {
     await queryFulfilled
    } catch {
     queryClient.invalidateQueries('all-notification')
    }
   },
  }),
  readChatMessage: mutation<void, { chat_id: number }>({
   query: (body) => ({
    url: 'user/chat/read',
    method: 'post',
    body,
   }),
   async onQueryStarted(body, { queryFulfilled }) {
    if (body.chat_id) {
     markChatAsReadInCache(body.chat_id)
    }
    try {
     await queryFulfilled
    } catch {
     // Optional: Revert optimistic update if needed, but for "read" status it's usually acceptable to stay "read" until next fetch or let it correct itself.
    }
   },
  }),
 }),
})

export const {
 useNotificationChatActionMutation,
 useSendMessageMutation,
 useReadChatMessageMutation,
} = chatCrm
